import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["start", "end"]

  connect() {
    this.startPicker = flatpickr(this.startTarget, {
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      time_24hr: true,
      onChange: this.updateEndMin.bind(this)
    })

    this.endPicker = flatpickr(this.endTarget, {
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      time_24hr: true
    })
  }

  updateEndMin(selectedDates) {
    if (selectedDates.length > 0) {
      this.endPicker.set("minDate", selectedDates[0])
    }
  }

  disconnect() {
    this.startPicker?.destroy()
    this.endPicker?.destroy()
  }
}